/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-05 12:46:53
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-05-12 14:12:19
 * @FilePath: /unifyxp-v2-store-portal/App.tsx
 */
import { ConfigProvider } from 'antd';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import IntlProvider, {
  I18nContext,
  languageAntdLocale,
} from './locale/IntlProvider/IntlProvider';
import GlobalProvider from './src/constrains/GlobalProvider';
import AppRouter from './src/router';
import { store } from './src/store';

//import { CustomerService } from './src/components/CustomerServiceModal';

import useLogin from './src/hooks/useLogin';
// import { useLoadGeneral } from './src/hooks/useLoadGeneral';

import 'rc-slider/assets/index.css';
import './global/style.less';
import { iniSentry } from './sentry';

const Config1 = (props: any) => {
  const { lang } = React.useContext(I18nContext);
  const { children, ...rest } = props;
  return (
    <ConfigProvider locale={languageAntdLocale[lang]} {...rest}>
      {children}
    </ConfigProvider>
  );
};

iniSentry();
const App = () => {
  const { display } = useLogin();
  // const { loading } = useLoadGeneral();
  return (
    <>
      {display ? ( // && !loading
        <Provider store={store}>
          <IntlProvider>
            <Config1
              direction='ltr'
              getPopupContainer={(node) => {
                if (node) {
                  return node.parentNode;
                }
                return document.body;
              }}>
              <GlobalProvider>
                <AppRouter />
              </GlobalProvider>
            </Config1>
          </IntlProvider>
        </Provider>
      ) : null}
      {/* <CustomerService /> */}
    </>
  );
};

render(<App />, document.getElementById('root'));
